
export default class MemberList {
    
    static get selector() {
        return '.memberList';
    }

    constructor(el) {
        this.el = el;
        this.currentKey = 0;
        this.duration = 4000;
        this.items = this.getItems();
        this.seeAll = el.querySelector('.memberList__seeAll');
        
        if(this.items.length > 1){
            this.prev = el.querySelector('.memberList__prev');
            this.next = el.querySelector('.memberList__next');
            this.activeItem(this.items[this.currentKey]);
            this.activateTimer();
            this.setEvents();
        }
        else{
            this.abort();
        }
    }

    abort() {
        let control = this.el.querySelector('.memberList__controls');
            control.classList.add('memberList__controls--hidden');

        this.activeItem(this.items[this.currentKey]);
    }

    activateTimer() {
        this.isTimerOn = true;
        clearTimeout(this.timer);
        this.timer = setTimeout(()=> {
            this.activeItem(this.items[this.getRelativeKey(+1)]);
            this.activateTimer();
            
        }, this.duration)
    }

    desactivateTimer() {
        this.isTimerOn = false;
        clearTimeout(this.timer);
    }

    getItems() {
        let elements = this.el.querySelectorAll('.memberList__slide');
        let items = [];

        elements.forEach((element, index) => {
            let item = {};
                item.isActive = false;
                item.slide = element;
                item.key = index;
            items.push(item);
        });

        return items;
    }


    activeItem(item) {
        if(item.isActive) return;
        this.desactiveAllItem();

        item.slide.classList.add('memberList__slide--active');
        item.isActive = true;
        this.currentKey = item.key;
    }

    desactiveItem(item) {
        
        if(!item.isActive) return;
        item.slide.classList.remove('memberList__slide--active');
        item.isActive = false;
    }

    desactiveAllItem() {
        this.items.forEach(item => {
            this.desactiveItem(item);
        });
    }

    getRelativeKey(offset) {
        let value, direction = offset < 0 ? -1 : 1;
        offset = Math.abs(offset) > (this.items.length - 1) ? (Math.abs(offset) % (this.items.length - 1)) * direction: offset;
        value = this.currentKey + offset;
        if(value < 0) return this.items.length + value;
        if(value > (this.items.length - 1)) return value - this.items.length;
        return value;
    }

    setEvents() {
        this.prev.addEventListener('click', this.e_prev.bind(this));
        this.next.addEventListener('click', this.e_next.bind(this));
        this.seeAll.addEventListener('click', this.e_seeAll.bind(this));
        /* 
        this.items.forEach(item => {
            item.el.addEventListener('mouseenter', (e)=> {this.e_hoverIn(e, item) });
            item.el.addEventListener('mouseleave', (e)=> {this.e_hoverOut(e, item) });
        });*/
    }

    e_seeAll(){
        this.seeAll.parentNode.removeChild(this.seeAll);
        this.el.classList.add('memberList--seeAll');
    }

    e_hoverIn(e, item) {
        this.activeItem(item);
        this.desactivateTimer();
    }

    e_hoverOut(e, item) {
        this.activateTimer();
    }

    e_prev(e) {
        e.preventDefault();
        e.target.blur();
        this.activeItem(this.items[this.getRelativeKey(-1)]);
        this.activateTimer();
    }

    e_next(e) {
        e.preventDefault();
        console.log(e.target);
        e.target.blur();
        this.activeItem(this.items[this.getRelativeKey(+1)]);
        this.activateTimer();
    }
}
